import { create } from 'zustand';

type ReportPanelStudyState = {
  targetStudyInstanceUID: string | null;
  setTargetStudyInstanceUID: (studyInstanceUID: string | null) => void;
  clearTargetStudyInstanceUID: () => void;
};

export const useReportPanelStudyStore = create<ReportPanelStudyState>(set => ({
  targetStudyInstanceUID: null,
  setTargetStudyInstanceUID: studyInstanceUID => set({ targetStudyInstanceUID: studyInstanceUID }),
  clearTargetStudyInstanceUID: () => set({ targetStudyInstanceUID: null }),
}));
